import React, { useMemo, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { generateYearsByMemberAge, ModalName, ValidateField } from '../../shared/constants/global';
import LifePlanModal from '../../shared/components/modal';
import { closeModal, openSubModal, saveSelectedLifeEvent } from '../../redux/lifePlan';
import InputText from '../../shared/components/input-field';
import CommaInput from '../../shared/components/comma-input-field';
import { Form, Field, Formik } from 'formik';
import { YupSchema } from '../../shared/constants/validators';
import SelectFieldSecond from '../../shared/components/select-field-second';
import { LifePlansImages } from '../../assets/images';
import { cloneDeep } from "lodash";

const {imgCar1, imgCar2, imgCar3, imgCar4, imgCar5, imgCar6, imgCar7, imgCar8} = LifePlansImages;
const arrImages = [imgCar1, imgCar2, imgCar3, imgCar4, imgCar5, imgCar6, imgCar7, imgCar8];

export default function EventCarModal(props) {
  const { t } = useTranslation('eventCarModal');
  const tGlobal = useTranslation('global').t;
  const dispatch = useDispatch();
  const { lifeEvent } = props;
  const uuid = useSelector(state => state.lifeEventSelected.uuid);
  const storeLifeEvents = useSelector(state => state.life_plan.life_event);

  const formState = useRef();

  const [selectedValue, setSelectedValue] = useState('');
  const [checkShow, setCheckShow] = useState(false);
  const [initialValues, setInitialValues] = useState({ ...props.lifeEvent, other: { ...props.lifeEvent.other } });

  const validateSchema = useMemo(() => {
    return new YupSchema(t).eventCarModal;
  }, []);

  const dataFrequency = useMemo(() => {
    let result = []
    for (let i = 1; i <= ValidateField.EventCarModal.MAX_FREQUENCY; i++) {
      result.push(i)
    }
    return result;
  }, []);

  useEffect(() => {
    const values = { ...props.lifeEvent, other: { ...props.lifeEvent.other } }
    setInitialValues(values)
    setCheckShow(values.other.detail == 8)
    if (uuid) {
      let cycleYear = storeLifeEvents.find((event) => event.uuid === uuid).year
      formState.current.setFieldValue("year", cycleYear);
    }
  }, [props.lifeEvent]);

  const handleClose = () => {
    dispatch(closeModal());
  }

  const getDetailName = (detail, data) => {
    switch (detail) {
      case 1:
        return "軽自動車"
      case 2:
        return "国産セダン"
      case 3:
        return "国産ミニバン"
      case 4:
        return "国産高級車"
      case 5:
        return "外車"
      case 6:
        return "高級外車"
      case 7:
        return "スーパーカー"
      case 8:
        return data.other?.custom || ""
      default:
        return ""
    }
  }

  const prepareData = (values) => {
    const tempData = cloneDeep(values);
    const params = {
      ...tempData,
      other: {
        ...tempData.other,
        detail_name: getDetailName(+tempData.other?.detail, tempData)
      }
    }
    return params;
  }

  const handleSubmitFinal = async () => {
    await formState.current.setFieldTouched();
    await formState.current.validateForm()

    if (!formState.current.isValid) {
      console.log('form invalid');
      return;
    }

    const { values } = formState.current;
    try {
      const data = prepareData(values);
      dispatch(saveSelectedLifeEvent(data));
    } catch (e) {
      console.log(e)
    }
  }

  const yearMapping = {}
  generateYearsByMemberAge().map((y) => yearMapping[y.year] = y.age)

  const renderYearFromNow = (year) => {
    return `${subYear(year)}歳（${year}年）`
  }

  const subYear = (year) => {
    const age = yearMapping[year];
    return age;
  }

  const handleRemove = () => {
    dispatch(openSubModal(ModalName.LIFEPLAN_CONFIRM_DELETE))
  }

  const onSelect = (data) => {
    setSelectedValue(+data)
    if (+formState.current.values.end_year < +data) {
      formState.current.setFieldValue("end_year", +data);
    }
  }

  const dataEndYear = useMemo(() => {
    if (!selectedValue) {
      return Object.keys(yearMapping).filter(ele => {
        if (uuid) {
          let cycleYear = storeLifeEvents.find((event) => event.uuid === uuid).year
          return +ele >= cycleYear
        } else {
          return +ele >= initialValues.year
        }
      });
    } else {
      return Object.keys(yearMapping).filter(ele => {
        return +ele >= +selectedValue;
      });
    }
  }, [selectedValue, initialValues.year])

  return <LifePlanModal name={ModalName.LIFEPLAN_EVENT_CAR} >
    <Formik
      enableReinitialize={true}
      initialValues={initialValues}
      validationSchema={validateSchema}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formikProps) => {
        const { values, setFieldValue, handleSubmit } = formikProps;
        formState.current = formikProps;

        return (
          <Form onSubmit={handleSubmit}>
            <div className="popupBox">
              <div className="popupInner">
                <div className="lifeplanPopup">
                  <h2>{t('label')}</h2>
                  <div className="popupContents">
                    <div className="popupContentsCover">
                      <div id="checkshow1" className="whiteBox checkShowToggle radioImgBox pad24 padBottom8">
                        <ul className="radioImgBtnList rowList">
                          {[...Array(8)].map((e, i) => {
                            return <li key={i}><label className={`radioBtn ${i + 1 == values.other.detail ? "checked" : ""}`}>
                                    <Field onClick={() => setCheckShow(i == 7)}
                                      type="radio" value={i + 1} name="other.detail" className="toggle_hide" />
                                    <img src={arrImages[i]} /><span>{t(`options.${i}`)}{t(`cost.${i}`)}</span>
                                  </label></li>
                          })}
                        </ul>
                      </div>
                    </div>
                    <dl className="formSty lifeplanImgBtnBox marB40">
                      <dt id="checkShow1-ttl" className={`checkShow1 dF aisC ${!checkShow ? 'hiddenTtl' : ''}`}>{t('custom')}</dt>
                      <dd id="checkShow1-item" className={`checkShow1 ${!checkShow ? 'hiddenItem' : ''} formTtlSty nowrap`}>
                        <div className="maxWidth400">
                          <Field className="toggle-item" type="text" component={InputText} name="other.custom" placeholder={t('customPlaceholder')} disabled={!checkShow} dF={true} />
                        </div>
                        <dl className="formTtlSty nowrap wid380 marL40">
                          <dt>{t('amount')}</dt>
                          <dd>
                            <Field className="wid120" placeholder="400" type="text" component={CommaInput} name="other.cost_at_first" disabled={!checkShow} secondLabel={tGlobal('tenThousandYen')} setFieldValue={setFieldValue} />
                          </dd>
                        </dl>
                      </dd>
                      <dt>{t('holdingPeriod')}</dt>
                      <dd className="dF jcFS">
                        <div className="dF aisC spFlexWrap">
                          <div className="dF aisC holdingPeriod">
                            <Field component={SelectFieldSecond} width="wid180" name="year" customChange={onSelect} options={Object.keys(yearMapping)} display_options={renderYearFromNow} />
                            {tGlobal('from')}
                          </div>
                          <div className="dF aisC">
                            <Field component={SelectFieldSecond} width="wid180" name="end_year" options={dataEndYear} display_options={renderYearFromNow} />
                            {tGlobal('to')}　
                          </div>
                          <div className="dF aisC spFlexWrap">
                            <span className="fontWB">{t('frequency_year')}</span>
                            <div className="dF aisC">
                              <Field component={SelectFieldSecond} width="wid180" name="other.frequency_year" options={dataFrequency} />
                              {tGlobal('rebuy')}
                            </div>
                          </div>
                        </div>
                      </dd>
                    </dl>
                    <div className="popupBtnBox">
                      <ul className="btnList col2">
                        <li><button type="button" className="btnSty-back" onClick={handleClose}>{tGlobal('cancel')}</button></li>
                        <li><button type="submit" className="btnSty-send" onClick={handleSubmitFinal}>{tGlobal('send')}</button></li>
                        { lifeEvent && lifeEvent.uuid && <li className="btnSty-delete"><button type="button" onClick={handleRemove}>{tGlobal('delete')}</button></li> }
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )
      }}
    </Formik>
  </LifePlanModal>
}
